import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

import AuthenticationApi from 'services/authentication';

export const AuthenticationContext = createContext();

function AuthenticationContextProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [authenticatedUserProfile, setAuthenticatedUserProfile] = useState({
    name: '',
    email: '',
  });

  async function login(payload) {
    const { data } = await AuthenticationApi.login(payload);
    const accessToken = _.get(data, ['data', 'access_token'], null);
    const userProfile = _.get(data, ['data', 'admin'], null);

    if (accessToken && userProfile) {
      localStorage.setItem('cms_token', accessToken);
      localStorage.setItem('current_admin', userProfile.email);

      setAuthenticated(true);
      setAuthenticatedUserProfile(userProfile);
    }

    window.location.reload();
  }

  return (
    <AuthenticationContext.Provider
      value={{
        authenticated,
        authenticatedUserProfile,
        login,
      }}>
      {children}
    </AuthenticationContext.Provider>
  );
}

AuthenticationContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.object,
};

export default AuthenticationContextProvider;
